function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(10)"
}, /*#__PURE__*/React.createElement("path", {
  fillOpacity: 0.5,
  id: "prefix__b",
  d: "M1.596 3.497a3.926 3.926 0 013.927 3.926 1 1 0 01-1.993.117l-.007-.117-.006-.15a1.925 1.925 0 00-1.92-1.776 1 1 0 110-2zM2.305 0A6.716 6.716 0 019.02 6.715a1 1 0 01-2 0A4.716 4.716 0 002.305 2a1 1 0 110-2z"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 1)"
}, /*#__PURE__*/React.createElement("path", {
  id: "prefix__d",
  d: "M2.413.99c1.115-.96 2.484-.946 3.558.058.729.682 1.458 1.42 2.201 2.223.88.95.88 2.417.017 3.347l-.2.223-.13.137-.455.46a10.31 10.31 0 003.677 3.407 1.001 1.001 0 01-.962 1.754 12.302 12.302 0 01-4.855-4.842 1 1 0 01.209-1.23l.115-.099.624-.627.27-.278.224-.245a.477.477 0 000-.648 42.757 42.757 0 00-2.101-2.122c-.321-.3-.539-.302-.884-.004-.14.121-.267.238-.421.39l-.259.262-.585.605a1.667 1.667 0 00-.45 1.288c.03.64.17 1.272.42 1.893.64 1.695 1.662 3.258 3.094 4.814a15.158 15.158 0 003.74 2.924c.852.505 1.775.883 2.706 1.114l.136.027.589.096.39-.005.303-.05c.234-.048.448-.157.61-.305a20.58 20.58 0 001.444-1.509.49.49 0 00-.008-.65 60.61 60.61 0 00-2.236-2.243 1 1 0 011.379-1.448 61.09 61.09 0 012.315 2.323c.866.929.894 2.36.071 3.317-.33.389-.686.77-1.126 1.208l-.468.459a3.345 3.345 0 01-1.832.85 1.052 1.052 0 01-.29.046l-.614.008-.179-.014-.692-.113-.24-.048a12.04 12.04 0 01-3.254-1.33l-.424-.243a17.117 17.117 0 01-3.788-3.056C2.453 11.377 1.292 9.602.564 7.67a7.618 7.618 0 01-.553-2.5 3.648 3.648 0 011.006-2.797l.608-.63c.23-.235.4-.403.574-.563l.214-.19z"
})));

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 20 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.bb9b2980.svg";
export { ForwardRef as ReactComponent };